const getProposalVersionString = (revisionNumber, minorRevisionNumber, isArchived) => {
  return `${revisionNumber}.${String.fromCharCode(97 + minorRevisionNumber)}${isArchived ? 'x' : ''}`
}

export const getTrialVersionString = (revisionNumber, minorRevisionNumber, isArchived, level = 0) => {
  return `${revisionNumber}.${minorRevisionNumber}.${level}${isArchived ? 'x' : ''}`
}

/**
 *
 * "Get parsed Revision Number from a DeckRevision"
 *
 * @file   numberToAlphabet.js
 * @author Lateral
 * @since  2023
 */
export function parsedRevisionNumberWithSubLetter(deckRevision) {
  /**
   * Convert number to String
   *
   * @function
   * @param {DeckRevision} deckRevision - The revision to get the number from
   * @returns {String} String of the RevisionNumber
   */

  if (deckRevision.IsTrial) {
    return getTrialVersionString(
      deckRevision.RevisionNumber,
      deckRevision.MinorRevisionNumber,
      deckRevision.IsArchived,
      deckRevision.RevisionLevel ?? 0
    )
  } else if (deckRevision.IsProposal) {
    return getProposalVersionString(
      deckRevision.RevisionNumber,
      deckRevision.MinorRevisionNumber,
      deckRevision.IsArchived
    )
  }

  return deckRevision.RevisionNumber
}

export function parsedRevisionNumber(deckRevision) {
  /**
   * Convert number to String
   *
   * @function
   * @param {DeckRevision} deckRevision - The revision to get the number from
   * @returns {String} String of the RevisionNumber
   */

  return `${deckRevision.RevisionNumber}.${deckRevision.MinorRevisionNumber ?? 0}`
}
